import { useContext } from "react";
import { VictimsAndKillersContext } from "../context/VictimsAndKillersContext";

export function useVictimsAndKillers() {
  const ctx = useContext(VictimsAndKillersContext);
  if (!ctx) throw new Error("useKillers must be used within KillersProvider");
  return ctx;
}
